<template>
  <el-dialog
    title="添加城建招标"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form size="small" :model="form" ref="form" :rules="rules" label-width="120px">
        <div class="common-form">添加城建招标</div>

        <el-form-item label="招标名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入招标名称" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="招标编号" prop="code">
          <el-input v-model="form.code" placeholder="请输入招标编号" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="招标类型" prop="status" >
          <el-radio-group v-model="form.status" @change="handleTypeChange">
            <el-radio :label="1">政府招标</el-radio>
            <el-radio :label="2">企业招标</el-radio>
          </el-radio-group>
        </el-form-item>
       <el-form-item label="关联项目" prop="products">
  <el-select 
    v-model="form.product_cp_id" 
    multiple
    placeholder="请选择项目（可多选）"
    class="max-w460">
    <el-option
      v-for="item in productOptions"
      :key="item.product_cp_id"
       @change="selectProduct"
      :label="item.label"
      :value="item.product_cp_id">
    </el-option>
  </el-select>
</el-form-item> 

        <el-form-item label="预算金额(万元)" prop="budget">
          <el-input-number v-model="form.budget" :min="0" :precision="2" class="max-w460"></el-input-number>
        </el-form-item>

        <el-form-item label="截至时间" prop="endTime">
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            placeholder="选择截至时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="max-w460">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="招标单位" prop="company">
          <el-input v-model="form.company" placeholder="请输入招标单位" class="max-w460"></el-input>
        </el-form-item>
            <el-form-item label="招标地区" prop="region">
          <el-input v-model="form.region" placeholder="请输入您的地区" class="max-w460"></el-input>
        </el-form-item>


        <el-form-item label="联系人" prop="contact">
          <el-input v-model="form.contact" placeholder="请输入联系人" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入联系电话" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="招标bannar：" prop="bannar">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.bannar">
              <transition-group>
                <div v-for="(item, index) in form.bannar" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')"><i class="el-icon-close"></i></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('bannar')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="招标图片：" prop="image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.image">
              <transition-group>
                <div v-for="(item, index) in form.image" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')"><i class="el-icon-close"></i></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="招标内容" prop="content">
          <div class="edit_container">
            <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
          </div>
        </el-form-item>

        <el-form-item label="招标要求" prop="request">
          <div v-for="(item, index) in form.request" :key="index" class="requirement-item">
            <el-input v-model="form.request[index]" placeholder="请输入招标要求" class="max-w460"></el-input>
            <el-button @click="removeRequirement(index)" type="text" icon="el-icon-delete"></el-button>
          </div>
          <el-button @click="addRequirement" type="text" icon="el-icon-plus">添加要求</el-button>
        </el-form-item>
        <!-- <el-form-item label="相关附件" prop="annex">
         <el-upload
    action="/api/urban/upload"
    multiple
    :file-list="form.attachments"
    :on-preview="handlePreview"
    :on-success="handleUploadSuccess"
    :on-remove="handleRemove"
    :before-upload="beforeUpload"
    :limit="5"
    :on-exceed="handleExceed"
    list-type="picture-card">
    <el-button size="small" type="primary">点击上传</el-button>
    <div slot="tip" class="el-upload__tip">支持扩展名：.pdf/.doc/.docx/.xls/.xlsx，单个文件不超过10MB</div>
  </el-upload>
        </el-form-item> -->
            <el-form-item label="相关图片" prop="annex">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.annex">
              <transition-group>
                <div v-for="(item, index) in form.annex" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'annex')"><i class="el-icon-close"></i></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('annex')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" class="max-w460"></el-input-number>
        </el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
    </div>
  </el-dialog>
</template>

<script>
import Product_cpApi from '@/api/product_cp.js';
import UrbanApi from '@/api/urban.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: {
    Upload,
    draggable,
    Uediter
  },
  data() {
    return {
       productOptions: [],
        productMap: {},
      isupload: false,
      isImg: false,
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      form: {
        annex:[],
        product_cp_id: [], 
        name: '',
        code: '',
        //status: 1,
        status: '',
        region:'',
        budget: 0,
       // endTime: '',
        company: '',
        contact: '',
        phone: '',
        intro: '',
        request: [''],
       // attachments: [],
        image: [],
        bannar: [],
        sort: 50
      },
      loading: false,
      rules: {
        name: [{ required: true, message: '请输入招标名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入招标编号', trigger: 'blur' }],
        status: [{ required: true, message: '请选择招标类型', trigger: 'change' }],
        company: [{ required: true, message: '请输入招标单位', trigger: 'blur' }],
        image: [{ required: true, message: '请上传招标图片', trigger: 'blur' }]
      },
      dialogVisible: false,
      isProductUpload: false,
      code: "album"
    };
  },
  async created() {
    this.dialogVisible = this.open_add;
 await  this.getCategory();
    this.updateProductOptions();
   this.getCategory();
  },
  props: ["open_add"],
  methods: {
     getCategory(){
      Product_cpApi.getCategory().then((res=> {
        this.productMap = res.data.productMap
      }))
    },
     selectProduct(){
      console.log('form.product_cp_id',this.form.product_cp_id);
      
    },
     updateProductOptions() {
      console.log('this.form.status',this.form.status);
    this.productOptions = this.productMap[this.form.status];
     console.log('productOptions',this.productOptions);
      this.form.product_cp_id = [];//name
  },
  handleTypeChange() {
    this.updateProductOptions();
  },

    addRequirement() {
      this.form.request.push('');
    },
    removeRequirement(index) {
      this.form.request.splice(index, 1);
    },
    // handleUploadSuccess(response, file, fileList) {
    //   this.form.attachments = fileList.map(item => ({
    //     name: item.name,
    //     url: item.response ? item.response.url : item.url
    //   }));
    // },
    // handleRemove(file, fileList) {
    //   this.form.attachments = fileList;
    // },
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    cancelFunc() {
      this.dialogFormVisible("error");
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      
      if (form.image.length <= 0) {
        self.$message({
          message: "请上传图片",
          type: 'error'
        });
        return;
      }
      
      form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          UrbanApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    openProductUpload(code) {
      this.isProductUpload = true;
      this.code = code;
    },
    returnProductImgsFunc(e) {
if (e != null) {
    let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
    let prevent = false;
    
    // 验证图片类型
    e.forEach((element) => {
      let data_array = element.file_path.split(".");
      let ext = data_array[data_array.length - 1];
      imgExpt.forEach((e) => {
        if (e === ext) {
          prevent = true;
          return false;
        }
      });
    });

    if (!prevent) {
      this.$message.error("图片类型有误,请选择正确的图片格式");
      return false;
    }

    // 根据code类型将图片存入对应的数组
    if (this.code === 'album') {
      let imgs = this.form.image.concat(e);
      this.$set(this.form, "image", imgs);
    } else if (this.code === 'bannar') {
      let imgs = this.form.bannar.concat(e);
      this.$set(this.form, "bannar", imgs);
    } else if (this.code === 'annex') {
      let imgs = this.form.annex.concat(e);
      this.$set(this.form, "annex", imgs);
    }
  }
  this.isProductUpload = false;
    },
   deleteImg(index, code) {
  if (code === 'album') {
    this.form.image.splice(index, 1);
  } else if (code === 'bannar') {
    this.form.bannar.splice(index, 1);
  } else if (code === 'annex') {
    this.form.annex.splice(index, 1);
  }
}
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.requirement-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.requirement-item .el-input {
  flex: 1;
  margin-right: 10px;
}

.max-w460 {
  width: 460px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/urban/index/part/add.vue